<script setup lang="ts">
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useResultsV2Store } from "@stores/survey/resultsV2/resultsV2";

const { currentView, viewName, baseRespondents } = storeToRefs(useResultsV2Store());
const cover = computed(() => currentView.value?.export_cover || {});
</script>

<template>
  <div
    class="hidden flex-col items-center justify-center text-center print:flex print:min-h-[345mm] print:break-after-page">
    <h1 class="text-[28pt] font-bold leading-tight tracking-tight">{{ cover.title }}</h1>
    <p class="mt-3 text-[16pt] text-muted-foreground">{{ viewName }}</p>

    <div class="mt-12 space-y-1.5 text-13 text-muted-foreground">
      <p v-if="cover.account">Account: {{ cover.account }}</p>
      <p v-if="baseRespondents">Respondents: {{ baseRespondents }}</p>
      <p v-if="cover.language">Language: {{ cover.language }}</p>
      <p v-if="cover.status">Status: {{ cover.status }}</p>
      <p>Exported: {{ cover.exported_on }}</p>
    </div>
  </div>
</template>
